import { render, staticRenderFns } from "./AsideViewAdsAd.vue?vue&type=template&id=2afcf052&scoped=true&"
import script from "./AsideViewAdsAd.vue?vue&type=script&lang=js&"
export * from "./AsideViewAdsAd.vue?vue&type=script&lang=js&"
import style0 from "./AsideViewAdsAd.vue?vue&type=style&index=0&id=2afcf052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcf052",
  null
  
)

export default component.exports